// @flow

const STATE = 'state';
const ROUTER = 'router';
const CONFIG = 'config';
const DMS_POLICY_SERVICE = 'dms-policy-service';
const DMS_PROGRAM_SERVICE = 'dms-program-service';
const DMS_REQUESTS_SERVICE = 'dms-requests-service';
const DMS_FILTER_SERVICE = 'dms-filter-policy-service';
const DMS_NOTIFICATION_SERVICE = 'dms-notification-service';
const DMS_MEDICAL_OFFICES_SERVICE = 'dms-medical-offices-service';
const DMS_MEDICAL_SERVICES_SERVICE = 'dms-medical-services-service';
const DMS_FRANCHISE_SERVICE = 'dms-franchise-service';
const DMS_THIRD_PARTY_SERVICE = 'dms-third-party-service';
const DMS_FAMILY_SERVICE = 'dms-family-service';
const DMS_UPGRADE_SERVICE = 'dms-upgrade-service';
const DMS_MEDICAL_CARE_SERVICE = 'dms-medical-care-service';
const DMS_SERVICES = 'dms-available-services';
const DMS_AMBULANCE_SERVICE = 'dms-ambulance-service';

const DMS_CHAT_SERVICE = 'dms-chat-service';

const DMS_THEME = 'dms-theme';
const DMS_POPUP = 'dms-popup-service';

const API_BASE_URL = ['lk', 'profiles', 'my', 'dms'];

const SERVICES = {
	STATE,
	CONFIG,
	ROUTER,
	DMS_THEME,
	DMS_POLICY_SERVICE,
	DMS_FILTER_SERVICE,
	DMS_PROGRAM_SERVICE,
	DMS_REQUESTS_SERVICE,
	DMS_NOTIFICATION_SERVICE,
	DMS_MEDICAL_OFFICES_SERVICE,
	DMS_MEDICAL_SERVICES_SERVICE,
	DMS_FRANCHISE_SERVICE,
	DMS_THIRD_PARTY_SERVICE,
	DMS_FAMILY_SERVICE,
	DMS_UPGRADE_SERVICE,
	DMS_MEDICAL_CARE_SERVICE,
	DMS_SERVICES,
	DMS_CHAT_SERVICE,
	DMS_POPUP,
	DMS_AMBULANCE_SERVICE,
};

export {
	SERVICES,
	API_BASE_URL,
};
